import styled, { css } from 'styled-components'

export const Progress = styled.div.attrs(props => ({
  className: "progress",
}))`
  margin-bottom: 1rem;
`

export const ProgressBar = styled.div.attrs(props => ({
  className: "progress-bar bg-success progress-bar-striped progress-bar-animated",
  ariaValuemin: "0",
  ariaValuemax: "100",
}))`
  width: 100%;
`